const CONSTANTS = {
  BASE_API_URL: "https://lab-api.skymdstaging.com/path/v1",
  HEADER_LOGO: "https://www.skymdstaging.com/src/img/logo1.png",
};

export default CONSTANTS;
